import { Divider, Card } from '@blueprintjs/core';
import { email } from '@axo/shared/data-access/types';
import { CreatedAtTag, CreatorTag, EmailIcon } from '../CommunicationItem';
import cardClasses from '../CommunicationItem/Card.module.css';

interface IEmailCardView {
  email: email.Email;
  template?: email.EmailTemplate;
  to: string;
}

export function EmailCardView({ email, to, template }: IEmailCardView) {
  return (
    <Card className={cardClasses.card}>
      <div className={cardClasses.topBar}>
        <EmailIcon />
        <CreatorTag creatorID={email.CreatorID} />
        <CreatedAtTag label="Sent at:" createdAt={email.CreatedAt} />
        <div className={cardClasses.fill} />
      </div>
      <Divider />
      <div className={cardClasses.body}>
        <div className={cardClasses.formRow}>
          <span className={cardClasses.label}>To: </span>
          <span className={cardClasses.fill}>{to}</span>
        </div>
        {template && (
          <div className={cardClasses.formRow}>
            <span className={cardClasses.label}>Name:</span>
            <span>{template?.Name}</span>
          </div>
        )}
        {template?.AllowsCustomContent && (
          <div className={cardClasses.formRow}>
            <span className={cardClasses.label}>Subject: </span>
            <span className={cardClasses.fill}>{email.Subject}</span>
          </div>
        )}
        {template?.AllowsCustomContent && (
          <div>
            <Divider />
            <span>{email.Body}</span>
          </div>
        )}
      </div>
    </Card>
  );
}
